import * as React from 'react';
import {useTranslation} from "react-i18next";
import {Box, CircularProgress, Divider} from "@mui/material";
import {Adjust, CheckCircle, Payment} from "@mui/icons-material";

import NavBar from "../../components/NavBar";
import Sender from "./sender";
import Receiver from "./receiver";
import BoxInfo from "./boxInfo";
import Services from "./services";
import Review from "./review";
import Invoice from "./invoice";
import {useDispatch, useSelector} from "react-redux";
import {setLoading} from "../../redux/loading/actions";
import {setListServices, setSelectedServicesFromMap} from "../../redux/singleOrder/services/actions";
import {setListReview} from "../../redux/singleOrder/review/actions";
import {createSearchParams, useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {checkEmail, checkNonZeroPrefix, handleCheckAddressWithState, handleScrollIntoView, HandleValidationMethod, useShowMessageComponent} from "../../assets/js/main";
import HandleFetchData from "../../plugin/HandleFetchData";
import {setLatSender, setLngSender} from "../../redux/singleOrder/sender/actions";
import {ThemeContext} from "../../App";
import {setValidations} from "../../redux/public/actions";


export default function SingleOrder() {
  const {t} = useTranslation()
  const {fetchData} = HandleFetchData()
  const {showMessageComponent} = useShowMessageComponent()
  const {validationMethod} = HandleValidationMethod()

  const location = useLocation();
  const theme = React.useContext(ThemeContext)

  const firstNameRefSender = React.useRef()
  const lastNameRefSender = React.useRef()
  const postalCodeRefSender = React.useRef()
  const mobileRefSender = React.useRef()
  const addressRefSender = React.useRef()
  const phoneRefSender = React.useRef()
  const emailRefSender = React.useRef()
  const companyRefSender = React.useRef()
  const coordinateRefSender = React.useRef()

  const firstNameRefReceiver = React.useRef()
  const lastNameRefReceiver = React.useRef()
  const postalCodeRefReceiver = React.useRef()
  const mobileRefReceiver = React.useRef()
  const addressRefReceiver = React.useRef()
  const coordinateRefReceiver = React.useRef()
  const phoneRefReceiver = React.useRef()
  const emailRefReceiver = React.useRef()
  const companyRefReceiver = React.useRef()

  const stateAndCityRefSender = React.useRef()
  const stateAndCityRefReceiver = React.useRef()
  const infoRefSingle = React.useRef()
  const priceRefSingle = React.useRef()
  const weightRefSingle = React.useRef()
  const sizeRefSingle = React.useRef()
  const paymentMethods = React.useRef()

  const serviceSingleRef = React.useRef()
  const serviceSingleRef1 = React.useRef()

  const dispatch = useDispatch();
  const selector = useSelector((st) => st)
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const divarIncomId = searchParams.get('state') || localStorage.getItem('token-id')
  const [activeSteps, setActiveSteps] = React.useState([])
  const [step, setStep] = React.useState(0)
  const [indexEdit, setIndexEdit] = React.useState()
  const steps = [
    {
      name: t("singleOrder.step.t3"),
      id: 0
    },
    {
      name: t("singleOrder.step.t4"),
      id: 1
    },
    {
      name: t("singleOrder.step.t1"),
      id: 2
    },
    {
      name: t("singleOrder.step.t2"),
      id: 3
    },
    {
      name: t("singleOrder.step.t5"),
      id: 4
    },
  ];


  //--------------Invoices----------------
  const [items_Invoices, setItems_Invoices] = React.useState(null);
  const [paymentMethod, setPaymentMethod] = React.useState(null);
  const [discountCode, setDiscountCode] = React.useState(null);


  React.useEffect(() => {
    window.scrollTo(0, 0);



    dispatch(setLngSender(selector?.single_sender?.lng))
    dispatch(setLatSender(selector?.single_sender?.lat))
  }, [step]);


  const nextStep = () => {
    setActiveSteps([...activeSteps, step])
    setStep(step + 1)
    dispatch(setValidations(null))
  }
  const preStep = () => {
    if (step === 1) {
      dispatch(setSelectedServicesFromMap(null))
    }

    if (step === 4) {
      dispatch(setListReview([]))
      setItems_Invoices(null)
    }
    setActiveSteps(activeSteps.slice(0, -1))
    setStep(step - 1)
    setItems_Invoices(null)
  }
  const handleBtnStep = (e) => {
    const is_item = activeSteps.includes(e)
    if(is_item){
      setStep(e)
    }
  }

  const validationsItems = () => {
    step === 0 ? validationsInfoBoxInfo() :
       step === 1 ? validationsInfoService() :
          step === 2 ? validationsInfoSender() :
             step === 3 ? validationsInfoReceiver() : validationsInfoReview()
  }

  const validationsInfoSender = () => {
    if (!selector?.single_sender?.address) {
      validationMethod(addressRefSender, 'address_validation_Sender', t("error.t8"))
    } else if (selector?.single_sender?.address.length < 5) {
      validationMethod(addressRefSender, 'address_validation_Sender', t("error.t9"))
    } else if (selector?.single_sender?.address.length > 150) {
      validationMethod(addressRefSender, 'address_validation_Sender', t("error.t10"))
    } else if (!selector?.single_sender?.first_name) {
      validationMethod(firstNameRefSender, 'firstName_validation_Sender', t("error.t4") )
    } else if (selector?.single_sender?.first_name.length > 50) {
      validationMethod(firstNameRefSender, 'firstName_validation_Sender', t("error.t11"))
    } else if (!selector?.single_sender?.last_name) {
      validationMethod(lastNameRefSender, 'lastName_validation_Sender', t("error.t5"))
    } else if (selector?.single_sender?.last_name.length > 50) {
      validationMethod(lastNameRefSender, 'lastName_validation_Sender', t("error.t12"))
    } else if (!selector?.single_sender?.lat || !selector?.single_sender?.lng) {
      validationMethod(coordinateRefSender, 'coordinate_validation_Sender', t("error.t13"))
    } else if (selector?.single_sender?.postal_code && !checkNonZeroPrefix(selector?.single_sender?.postal_code)) {
      validationMethod(postalCodeRefSender, 'postalCode_validation_Sender', t("error.t14"))
    } else if (!selector?.single_sender?.mobile_number) {
      validationMethod(mobileRefSender, 'mobileNumber_validation_Sender', t("error.t6"))
    } else if (selector?.single_sender?.mobile_number?.length !== 11 || !selector?.single_sender?.mobile_number.startsWith("09")) {
      validationMethod(mobileRefSender, 'mobileNumber_validation_Sender', t("error.t7"))
    } else if (selector?.single_sender?.phone_number) {
      if(selector?.single_sender?.phone_number?.length !== 11 || !selector?.single_sender?.phone_number.startsWith("0")){
        validationMethod(phoneRefSender, 'phoneNumber_validation_Sender', t("error.t7"))
      }
    } else if (selector?.single_sender?.email && !checkEmail(selector?.single_sender?.email)) {
      validationMethod(emailRefSender, 'email_validation_Sender', t("error.t17"))
    } else if (selector?.single_sender?.company && selector?.single_sender?.company.length > 50) {
      validationMethod(companyRefSender, 'company_validation_Sender', t("error.t18"))
    } else {
      nextStep()
    }
  }
  const validationsInfoReceiver = () => {
    if (!selector?.single_receiver?.address) {
      validationMethod(addressRefReceiver, 'address_validation_Receiver', t("error.t8"))
    }else if (selector?.single_receiver?.address.length < 5) {
      validationMethod(addressRefReceiver, 'address_validation_Receiver', t("error.t9"))
    } else if (!selector?.single_receiver?.first_name) {
      validationMethod(firstNameRefReceiver, 'firstName_validation_Receiver', t("error.t4"))
    } else if (!selector?.single_receiver?.last_name) {
      validationMethod(lastNameRefReceiver, 'lastName_validation_Receiver', t("error.t5"))
    } else if (!divarIncomId && !selector?.single_receiver?.lat || !selector?.single_receiver?.lng) {
      validationMethod(coordinateRefReceiver, 'coordinate_validation_Receiver', t("error.t13"))
    } else if (selector?.single_receiver?.postal_code && !checkNonZeroPrefix(selector?.single_receiver?.postal_code)) {
      validationMethod(postalCodeRefReceiver, 'postalCode_validation_Receiver', t("error.t14"))
    } else if (!selector?.single_receiver?.mobile_number) {
      validationMethod(mobileRefReceiver, 'mobileNumber_validation_Receiver', t("error.t6"))
    } else if (selector?.single_receiver?.mobile_number?.length !== 11 || !selector?.single_receiver?.mobile_number.startsWith("09")) {
      validationMethod(mobileRefReceiver, 'mobileNumber_validation_Receiver', t("error.t7"))
    }else if (selector?.single_sender?.mobile_number === selector?.single_receiver?.mobile_number) {
      validationMethod(mobileRefReceiver, 'mobileNumber_validation_Receiver', t("error.t19"))
    } else if (selector?.single_receiver?.phone_number) {
      if(selector?.single_receiver?.phone_number?.length !== 11 || !selector?.single_receiver?.phone_number.startsWith("0")){
        validationMethod(phoneRefReceiver, 'phoneNumber_validation_Receiver', t("error.t16"))
      }
    } else if (selector?.single_receiver?.email && !checkEmail(selector?.single_receiver?.email)) {
      validationMethod(emailRefReceiver, 'email_validation_Receiver', t("error.t17"))
    }else if (selector?.single_receiver?.company && selector?.single_receiver?.company.length > 50) {
      validationMethod(companyRefReceiver, 'company_validation_Receiver', t("error.t18"))
    }else {
      addOrderToList()
    }
  }
  const validationsInfoBoxInfo = () => {
    if (!selector?.single_sender?.city_id) {
      validationMethod(stateAndCityRefSender, `state_and_city_validation_Sender`, t("error.t20"))
    } else if (!selector?.single_receiver?.city_id) {
      validationMethod(stateAndCityRefReceiver, 'state_and_city_validation_Receiver', t("error.t21"))
    } else if (!selector?.single_info_box?.size) {
      validationMethod(sizeRefSingle, 'size_validation_BoxInfo', t("error.t22"))
    } else if (!selector?.single_info_box?.weight) {
      validationMethod(weightRefSingle, 'weight_validation_BoxInfo', t("error.t23"))
    } else if (Number(selector?.single_info_box?.weight) < 50) {
      validationMethod(weightRefSingle, 'weight_validation_BoxInfo', t("error.t24"))
    } else if (!selector?.single_info_box?.price) {
      validationMethod(priceRefSingle, 'pricePost_validation_BoxInfo', t("error.t25"))
    } else if (!selector?.single_info_box?.info) {
      validationMethod(infoRefSingle, 'infoPost_validation_BoxInfo', t("error.t26"))
    } else if (!selector?.single_info_box?.payment_type) {
      validationMethod(paymentMethods, 'payment_type_validation_BoxInfo', t("error.t27"))
    } else {
      getServices()
    }
  }
  const validationsInfoService = () => {
    if (!selector?.single_services?.selectedService?.ServiceId) {
      handleScrollIntoView(serviceSingleRef)
      handleScrollIntoView(serviceSingleRef1)
      showMessageComponent(t("singleOrder.serviceType.t15"), 'error')
    } else if (!selector?.single_sender?.need && !selector?.single_services?.selectedServicesFromMap?.id) {
      showMessageComponent(t("singleOrder.serviceType.t26"), 'error')
    } else {
      nextStep()
    }
  }
  const validationsInfoReview = () => {
    nextStep()
  }


  const addOrderToList = () => {
    if (indexEdit) {
      let list = [...selector?.single_review?.listReview]
      list[Number(indexEdit)] = {
        "ServiceID": selector?.single_services?.selectedService?.ServiceId,
        "CodGoodsPrice": 0,
        "divarToken": divarIncomId || 0,
        "InsuranceName": "* انتخاب بیمه ضروری است *",
        "Sender_FristName": selector?.single_sender?.first_name,
        "Sender_LastName": selector?.single_sender?.last_name,
        "Sender_mobile": selector?.single_sender?.mobile_number,
        "Sender_StateId": selector?.single_sender?.state_id,
        "Sender_City": selector?.single_sender?.city_name,
        "Sender_townId": selector?.single_sender?.city_id,
        "Sender_PostCode": selector?.single_sender?.postal_code,
        "Sender_Address": selector?.single_sender?.address,
        "Sender_Email": selector?.single_sender?.email,
        "SenderLat": String(selector?.single_sender?.lat),
        "SenderLon": String(selector?.single_sender?.lng),
        "NeedCollector": selector?.single_sender?.need,


        "Reciver_FristName": selector?.single_receiver?.first_name,
        "Reciver_LastName": selector?.single_receiver?.last_name,
        "Reciver_mobile": selector?.single_receiver?.mobile_number,
        "Reciver_StateId": selector?.single_receiver?.state_id,
        "Reciver_City": selector?.single_receiver?.city_name,
        "Reciver_townId": selector?.single_receiver?.city_id,
        "Reciver_PostCode": selector?.single_receiver?.postal_code,
        "Reciver_Address": selector?.single_receiver?.address,
        "Reciver_Email": selector?.single_receiver?.email,
        "ReciverLat": String(selector?.single_receiver?.lat),
        "ReciverLon": String(selector?.single_receiver?.lng),
        "NeedDistributer": selector?.single_receiver?.need,

        "selectedOfficeAddress": !selector?.single_sender?.need
           ?
           ((selector?.single_services?.selectedServicesFromMap?.shopId ? '1' : "2") + '=' + selector?.single_services?.selectedServicesFromMap?.id)
           :
           '',
        "CartonSizeName": selector?.single_info_box?.size,
        "GoodsType": selector?.single_info_box?.info,
        "ApproximateValue": Number(String(selector?.single_info_box?.price)?.split(',').join('')),
        "Weight": Number(selector?.single_info_box?.weight),
        "IsCOD": selector?.single_info_box?.payment_type === 'cod',
        "IsFreePost": selector?.single_info_box?.payment_type === 'free',
        "IsSafeBuy": selector?.single_info_box?.payment_type === 'amnito',
        "HasAccessToPrinter": selector?.single_info_box?.factor,
        "AgentSaleAmount": Number(String(selector?.single_info_box?.agent_services)?.split(',').join('')) || 0,
        "discountCouponCode": discountCode,
        "length": selector?.single_info_box?.length,
        "width": selector?.single_info_box?.width,
        "height": selector?.single_info_box?.height,
        "boxType": 1,
        "Count": 1,
        "printLogo": selector?.single_info_box?.trademark,
        "notifBySms": selector?.single_info_box?.notification,
        "orderSource": process.env.REACT_APP_SITE === 'amnito' ? 24 : (localStorage.getItem('token-id') ? 21 : 22),
        "refrenceNo": "",
        "IsBreakable": selector?.single_info_box?.breakable,
        "IsLiquid": selector?.single_info_box?.liquid,
        "NeedCarton": selector?.single_info_box?.need,

        "affiliateName": sessionStorage.getItem('affiliate'),

        "shipmentTempId": selector?.single_services?.selectedService?.ServiceId,
        "CustomerDesc": "",
        "CustomerOrderNo": "213",

        "paymentType": selector?.single_info_box?.payment_type,
        "SLA": selector?.single_services?.selectedService
      }
      dispatch(setListReview(list))
      setIndexEdit(null)
      nextStep()
    } else {
      const item = {
        "ServiceID": selector?.single_services?.selectedService?.ServiceId,
        "GoodsType": selector?.single_info_box?.info,
        "ApproximateValue": Number(String(selector?.single_info_box?.price)?.split(',').join('')),
        "CodGoodsPrice": 0,
        "divarToken": divarIncomId || 0,
        "Weight": Number(String(selector?.single_info_box?.weight)?.split(',').join('')),
        "InsuranceName": "* انتخاب بیمه ضروری است *",
        "CartonSizeName": selector?.single_info_box?.size,
        "Sender_FristName": selector?.single_sender?.first_name,
        "Sender_LastName": selector?.single_sender?.last_name,
        "Sender_mobile": selector?.single_sender?.mobile_number,
        "Sender_StateId": selector?.single_sender?.state_id,
        "Sender_City": selector?.single_sender?.city_name,
        "Sender_townId": selector?.single_sender?.city_id,
        "Sender_PostCode": selector?.single_sender?.postal_code,
        "Sender_Address": selector?.single_sender?.address,
        "Sender_Email": selector?.single_sender?.email,
        "SenderLat": String(selector?.single_sender?.lat),
        "SenderLon": String(selector?.single_sender?.lng),
        "NeedCollector": selector?.single_sender?.need,


        "Reciver_FristName": selector?.single_receiver?.first_name,
        "Reciver_LastName": selector?.single_receiver?.last_name,
        "Reciver_mobile": selector?.single_receiver?.mobile_number,
        "Reciver_StateId": selector?.single_receiver?.state_id,
        "Reciver_City": selector?.single_receiver?.city_name,
        "Reciver_townId": selector?.single_receiver?.city_id,
        "Reciver_PostCode": selector?.single_receiver?.postal_code,
        "Reciver_Address": selector?.single_receiver?.address,
        "Reciver_Email": selector?.single_receiver?.email,
        "ReciverLat": String(selector?.single_receiver?.lat),
        "ReciverLon": String(selector?.single_receiver?.lng),
        "NeedDistributer": selector?.single_receiver?.need,

        "selectedOfficeAddress": !selector?.single_sender?.need
           ?
           ((selector?.single_services?.selectedServicesFromMap?.shopId ? '1' : "2") + '=' + selector?.single_services?.selectedServicesFromMap?.id)
           :
           '',

        "IsCOD": selector?.single_info_box?.payment_type === 'cod',
        "IsFreePost": selector?.single_info_box?.payment_type === 'free',
        "IsSafeBuy": selector?.single_info_box?.payment_type === 'amnito',
        "HasAccessToPrinter": selector?.single_info_box?.factor,
        "AgentSaleAmount": Number(String(selector?.single_info_box?.agent_services)?.split(',').join('')) || 0,
        "discountCouponCode": discountCode,
        "length": selector?.single_info_box?.length,
        "width": selector?.single_info_box?.width,
        "height": selector?.single_info_box?.height,
        "boxType": 1,
        "Count": 1,
        "printLogo": selector?.single_info_box?.trademark,
        "notifBySms": selector?.single_info_box?.notification,
        "orderSource": process.env.REACT_APP_SITE === 'amnito' ? 24 : (localStorage.getItem('token-id') ? 21 : 22),
        "refrenceNo": "",
        "IsBreakable": selector?.single_info_box?.breakable,
        "IsLiquid": selector?.single_info_box?.liquid,
        "NeedCarton": selector?.single_info_box?.need,

        "affiliateName": sessionStorage.getItem('affiliate'),

        "shipmentTempId": selector?.single_services?.selectedService?.ServiceId,
        "CustomerDesc": "",
        "CustomerOrderNo": "213",

        "paymentType": selector?.single_info_box?.payment_type,
        "SLA": selector?.single_services?.selectedService
      }
      let list = [...selector?.single_review?.listReview, item]
      dispatch(setListReview(list))
      nextStep()
    }
  }

  const handleUpdateDiscountCode = (e) => {
    let list = [...selector?.single_review?.listReview]
    list.map(i => {
      i.discountCouponCode = e
    })
    dispatch(setListReview(list))
  }

  const handlerEditItemListReview = (e) => {
    setIndexEdit(String(e?.index))
    setItems_Invoices(null)
    setStep(0)
    setActiveSteps([])

  }

  const handlerDeleteFromListReview = (i) => {
    let formValues = [...selector?.single_review?.listReview];
    formValues.splice(i, 1);
    dispatch(setListReview(formValues))
    setActiveSteps([])
    setStep(0)
    dispatch({type: 'RESET_STATE_SENDER_SINGLE'})
    dispatch({type: 'RESET_STATE_RECEIVER_SINGLE'})
    dispatch({type: 'RESET_STATE_BOX_SINGLE'})
    dispatch({type: 'RESET_STATE_REVIEW_SINGLE'})
    dispatch({type: 'RESET_STATE_SERVICES_SINGLE'})
  }

  const submitSingleOrder = async () => {
    dispatch(setLoading(true))
    let fetch = await fetchData('', 'POST', '/checkout/panelNewOrderList', selector?.single_review?.listReview,
       "application/json", '', '', ''
    )

    if (fetch?.success) {
      await showMessageComponent('ثبت سفارش با موفقیت انجام شد', 'success')
      nextStep()
    } else if (fetch && fetch?.status === 500) {
      navigate({
        pathname: "/pageInternalServer",
        search: location?.search
      });
    } else {
      showMessageComponent(fetch && fetch?.message, 'error')
    }
    setItems_Invoices(fetch)
    // setResApi(fetch)
    dispatch(setLoading(false))
    // nextStep()

  }

  const getServices = async () => {
    dispatch(setLoading(true))
    let fetch = await fetchData('', 'POST', '/getPostServices', {
         "weightItem": String(selector?.single_info_box?.weight)?.split(',').join(''),
         "AproximateValue": String(selector?.single_info_box?.price)?.split(',').join(''),
         "divarToken": divarIncomId || 0,
         "height": String(selector?.single_info_box?.height),
         "width": String(selector?.single_info_box?.width),
         "length": String(selector?.single_info_box?.height),
         "Content": selector?.single_info_box?.info,
         "IsCod": String(selector?.single_info_box?.payment_type === 'cod'),
         "boxType": "0",
         "ShowPrivatePost": (divarIncomId && selector?.single_info_box?.payment_type !== "online") ? false : true ,
         "orderSource": process.env.REACT_APP_SITE === 'amnito' ? 24 : (localStorage.getItem('token-id') ? 21 : 22),
         "SenderAddress": {
           "FirstName": selector?.single_sender?.first_name,
           "LastName": selector?.single_sender?.last_name,
           "Company": selector?.single_sender?.company,
           "Email": selector?.single_sender?.email,
           "PhoneNumber": selector?.single_sender?.mobile_number,
           "ZipPostalCode": selector?.single_sender?.postal_code,
           "Address1": selector?.single_sender?.address,
           "Lat": String(selector?.single_sender?.lat),
           "Lon": String(selector?.single_sender?.lng),

           "CountryId": String(selector?.single_sender?.state_id),
           "StateProvinceId": String(selector?.single_sender?.city_id),
           "CountryName": selector?.single_sender?.state_name,
           "StateProvinceName": selector?.single_sender?.city_name,
           "tehranCityArea": "",
           "collectorArea": "",
           "isInCityArea": "",
           "trafficArea": ""
         },
         "ReciverAddress": {
           "FirstName": selector?.single_receiver?.first_name,
           "LastName": selector?.single_receiver?.last_name,
           "Company": selector?.single_receiver?.company,
           "Email": selector?.single_receiver?.email,
           "PhoneNumber": selector?.single_receiver?.mobile_number,
           "ZipPostalCode": selector?.single_receiver?.postal_code,
           "Address1": selector?.single_receiver?.address,
           "Lat": String(selector?.single_receiver?.lat),
           "Lon": String(selector?.single_receiver?.lng),
           "CountryId": String(selector?.single_receiver?.state_id),
           "StateProvinceId": String(selector?.single_receiver?.city_id),
           "CountryName": selector?.single_receiver?.state_name,
           "StateProvinceName": selector?.single_receiver?.city_name,
           "tehranCityArea": "",
           "collectorArea": "",
           "isInCityArea": "",
           "trafficArea": ""
         },
         "IsBreakable": String(selector?.single_info_box?.breakable),
         "IsLiquid": String(selector?.single_info_box?.liquid),
         "NeedCollector": true,
         "NeedDistributer": true,
       },
       "application/json", '', '', ''
    )
    fetch?.IsSuccess ? nextStep() : showMessageComponent(fetch?.Message, 'error')

    if (fetch && fetch?.StatusCode == 500) {
      navigate({
        pathname: "/pageInternalServer",
        search: location?.search
      });
    }
    dispatch(setValidations(null))
    dispatch(setListServices(fetch?.Data))
    dispatch(setLoading(false))
  }

  const payOrder = async () => {
    dispatch(setLoading(true))
    let fetch = await fetchData('', 'POST', '/payment', {
         "orderId": Number(items_Invoices?.orderId),
         "paymentmethod": paymentMethod === "Payments.Wallet" ? "" : paymentMethod,
         "useRewardPoints": paymentMethod === "Payments.Wallet",
         "isForeign": false,
         "reciverPay": false,
         "DivarToken": divarIncomId || null,
         "callBackUrl": `https://${process.env.REACT_APP_SUBDOMAIN}.postex.ir/paymentStatus`
       },
       "application/json", '', '', ''
    )
    if (fetch?.IsSuccess) {
      if (paymentMethod === "Payments.Wallet") {
        navigate({
          pathname: "/paymentStatus",
          search: fetch?.Data?.divarToken ? createSearchParams({
               OrderId: fetch?.Data?.orderId,
               code: 0,
               state: fetch?.Data?.divarToken
             }).toString() :
             createSearchParams({
               OrderId: fetch?.Data?.orderId,
               code: 0,
             }).toString()
        });
        showMessageComponent(fetch?.Message, 'success')
      } else {
        window.open(fetch?.Data, '_self')
      }
    } else if (fetch && fetch?.StatusCode == 500) {
      navigate({
        pathname: "/pageInternalServer",
        search: location?.search
      });
    } else {
      showMessageComponent(fetch?.Message, 'error')
    }
    dispatch(setLoading(false))
  }

  return (
     <>
       {selector?.loading?.isLoading &&
       <div className="backdrop-loading">
         <div className="backdrop-bg">
           <div className="loader" style={theme.darkMode ? {backgroundImage: "url('/splash2.gif')"} : {backgroundImage: "url('/splash1.gif')"}}/>
         </div>
       </div>
       }

       <NavBar blue/>

       <div className="container">
         <div className="singleOrderPage desktopSection">

           {(step <= 4) && <>
             <div className="stepper-bar">
               <div className={`${'stepper'}  ${step === 3 && 'activation'}`}>
                 {
                   steps.map((item, index) => {
                     return (
                          <div key={index} className={`${'stepperItem'}`}>
                            <button type="button" className={step === index ? 'selected' : ''}
                                    onClick={() => handleBtnStep(item?.id)}>
                            {
                              activeSteps.includes(index)
                                 ?
                                 <CheckCircle className="check"/>
                                 :
                                 <Adjust/>
                            }
                            <p>{item?.name}</p>
                            </button>
                          </div>
                     )
                   })
                 }

               </div>

               <Divider/>

             </div>
           </>}

           <div className="row">
             <div className="col-12">
               <div className="bodyPage">

                 {step === 0 && <BoxInfo
                    stateAndCityRefSender={stateAndCityRefSender}
                    stateAndCityRefReceiver={stateAndCityRefReceiver}
                    infoRefSingle={infoRefSingle}
                    priceRefSingle={priceRefSingle}
                    weightRefSingle={weightRefSingle}
                    sizeRefSingle={sizeRefSingle}
                    paymentMethods={paymentMethods}
                 />}

                 {step === 1 && <Services
                    serviceSingleRef={serviceSingleRef}
                    serviceSingleRef1={serviceSingleRef1}
                 />}

                 {step === 2 && <Sender
                    firstNameRefSender={firstNameRefSender}
                    lastNameRefSender={lastNameRefSender}
                    postalCodeRefSender={postalCodeRefSender}
                    mobileRefSender={mobileRefSender}
                    addressRefSender={addressRefSender}
                    phoneRefSender={phoneRefSender}
                    emailRefSender={emailRefSender}
                    companyRefSender={companyRefSender}
                 />}

                 {step === 3 && <Receiver
                    firstNameRefReceiver={firstNameRefReceiver}
                    lastNameRefReceiver={lastNameRefReceiver}
                    postalCodeRefReceiver={postalCodeRefReceiver}
                    mobileRefReceiver={mobileRefReceiver}
                    addressRefReceiver={addressRefReceiver}
                    phoneRefReceiver={phoneRefReceiver}
                    emailRefReceiver={emailRefReceiver}
                    companyRefReceiver={companyRefReceiver}
                 />}


                 {step === 4 && <Review
                    handlerSteps={() => setStep(1)}
                    handlerActiveSteps={() => setActiveSteps([0, 1])}
                    handlerEditItemListReview={(event) => handlerEditItemListReview(event)}
                    handlerDeleteFromListReview={(event) => handlerDeleteFromListReview(event)}
                    handleDiscountCode={(event) => {
                      handleUpdateDiscountCode(event)
                      setDiscountCode(event)
                    }}
                    // handleDiscountCode={(event) => console.log(event)}

                    discountCode={discountCode}
                 />}

                 {step === 5 && <Invoice
                    handlePaymentMethod={(event) => setPaymentMethod(event)}
                    items={items_Invoices}
                    paymentMethod={paymentMethod}

                 />}

               </div>
             </div>
           </div>

           <div className="btn-stepper">
             <div className="btnGroup_blue">

               {step < 4 && <button className="btnFill btn-effect" disabled={selector?.loading?.isLoading} onClick={validationsItems} id="btnFill">
                 {
                   selector?.loading?.isLoading ?
                      <Box sx={{display: 'flex'}}>
                        <CircularProgress size={20}/>
                      </Box>
                      :
                      <>
                        <span>{t("singleOrder.t2")}</span>
                      </>
                 }
               </button>}

               {step === 5 && <button className="btnFill" disabled={selector?.loading?.isLoading} onClick={payOrder} id="payOrder">
                 {
                   selector?.loading?.isLoading ?
                      <Box sx={{display: 'flex'}}>
                        <CircularProgress size={20}/>
                      </Box>
                      :
                      <>
                        <span>{t("singleOrder.t4")}</span>
                        <Payment fontSize="medium"/>
                      </>
                 }
               </button>}


               {step === 4 && <>
                 <button className="btnFill" disabled={selector?.loading?.isLoading} onClick={() =>
                    selector?.single_review?.listReview?.length ?
                       submitSingleOrder()
                       :
                       setStep(0)
                 } id="submitSingleOrder">
                   {
                     selector?.loading?.isLoading ?
                        <Box sx={{display: 'flex'}}>
                          <CircularProgress size={20}/>
                        </Box>
                        :
                        <>
                          {
                            !selector?.single_review?.listReview?.length ?
                               <span>{t("singleOrder.review.t22")}</span>
                               :
                               <span>{t("singleOrder.t3")}</span>
                          }
                        </>
                   }
                 </button>
                 {/*  }*/}
               </>
               }

               {step > 0 && step <= 5 && <button className="btnEmpty" onClick={preStep}>
                 <span>{t("singleOrder.t1")}</span>
               </button>
               }

             </div>
           </div>
         </div>
       </div>
     </>

  );
}
